module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": _vm.prop_id
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _c('div', {
    staticClass: "modal-body internal-scroller"
  }, [_c('list', {
    ref: "tag_list",
    staticClass: "tag-modal-list",
    attrs: {
      "options": _vm.list_options,
      "list_item_options": _vm.list_item_options
    },
    on: {
      "selection-changed": _vm.selection_changed
    }
  })], 1), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-gray",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.pick
    }
  }, [_vm._v("Concluir")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_vm._v("Selecione uma ou mais tags"), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8bea8dd4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tags/picker_modal.vue
// module id = 1184
// module chunks = 1